module.exports = __webpack_public_path__ + "img/searchjobs.7afb7996.svg";